module.exports = __webpack_public_path__ + "d6ab2a3a919ef25c5f06ddf5600d4efc.svg";